import axios from 'axios';
import _ from 'lodash';
import qs from 'qs';
import { concedoAuthHeader } from 'middlewares/api-middleware';

const api = {
  get: (appState, url, params, baseUrl) => {
    const accessToken = _.get(appState, 'user.accessToken');
    const apiBaseUrl = baseUrl || window.Grab.config.getApiBaseUrl(_.get(appState, 'config.version'));
    return axios({
      url: `${baseUrl || apiBaseUrl}${url}`,
      headers: {
        'Content-Type': 'application/json',
        Authentication: accessToken,
        [concedoAuthHeader]: `bearer ${accessToken}`,
      },
      method: 'get',
      params,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    });
  },
};

export default api;
